<script lang="ts" setup>
const { t } = useEkI18n();
defineExpose({
  openModal
});
const emits = defineEmits<{
  select: [cvr: CvrInfo]
}>();
const isOpen = ref<boolean>(false);
const vatResult = ref<CvrInfo | null>(null);

function openModal(Vat: CvrInfo) {
  vatResult.value = Vat;
  isOpen.value = true;
}

const location = computed(() => {
  if (vatResult.value) {
    return `${vatResult.value.ZipCode} ${vatResult.value.City}, ${vatResult.value.Country}`;
  }

  return t('labels.notAvailable');
});

function reset() {
  isOpen.value = false;
  vatResult.value = null;
}

function select(cvr: CvrInfo) {
  emits('select', cvr);
  reset();
}
</script>

<template>
  <IonModal
    id="VatModal"
    :is-open="isOpen"
    class="ion-padding custom-ion-modal"
    @did-dismiss="isOpen = false;"
  >
    <IonToolbar>
      <IonTitle class="ion-no-padding">
        <div class="ion-text-wrap ion-padding">
          {{ t('customer.searchVatTitle') }}
        </div>
      </IonTitle>
      <IonButtons slot="end">
        <IonButton @click="isOpen = false">
          <IonIcon class="fa-light fa-xmark" />
        </IonButton>
      </IonButtons>
    </IonToolbar>
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {{ vatResult?.Name }}
        </IonCardTitle>
        <IonCardSubtitle>CVR: {{ vatResult?.CVR }}</IonCardSubtitle>
      </IonCardHeader>

      <IonCardContent>
        <div class="flex flex-col gap-1">
          <IonRow class="items-center gap-1">
            <IonIcon class="fa-fw fa-light fa-location-dot" />
            <span> {{ vatResult?.Address ?? t('labels.notAvailable') }} </span>
          </IonRow>
          <IonRow class="items-center gap-1">
            <IonIcon class="fa-fw fa-light fa-location-dot" />
            <span> {{ location }} </span>
          </IonRow>
          <IonRow class="items-center gap-1">
            <IonIcon class="fa-fw fa-light fa-phone" />
            <span>{{ vatResult?.Phone ?? t('labels.notAvailable') }}</span>
          </IonRow>
          <IonRow class="items-center gap-1">
            <IonIcon class="fa-fw fa-light fa-envelope" />
            <span>{{ vatResult?.Email ?? t('labels.notAvailable') }}</span>
          </IonRow>
        </div>
      </IonCardContent>
    </IonCard>
    <IonRow class="p-2">
      <IonCol>
        <IonButton
          expand="block"
          fill="outline"
          shape="round"
          @click="() => isOpen = false"
        >
          {{ t('buttons.cancel') }}
        </IonButton>
      </IonCol>
      <IonCol>
        <IonButton
          expand="block"
          shape="round"
          @click="vatResult && select(vatResult)"
        >
          {{ t('buttons.apply') }}
        </IonButton>
      </IonCol>
    </IonRow>
  </IonModal>
</template>

<style scoped>
.custom-ion-modal {
  --height: auto;
  --border-radius: 16px;
}
</style>